import * as actionTypes from './actionTypes';

// export const checkRouterSpeedVisiblity = () => ({
//   type: actionTypes.GET_RSC_IS_AVAILABLE
// })

export const setRouterSpeedVisiblity = (routerSpeedCheckVisible) => ({
  type: actionTypes.SET_RSC_IS_AVAILABLE,
  routerSpeedCheckVisible,
})

export const getSpeedCheckStartDate = () => ({
  type: actionTypes.GET_RSC_START_TIME
})

export const setSpeedCheckStartDate = (speedCheckStartDate) => ({
  type: actionTypes.SET_RSC_START_TIME,
  speedCheckStartDate,
})

export const getSpeedCheckResults = () => ({
  type: actionTypes.GET_RSC_RESULTS
})

export const setSpeedCheckResults = (speedCheckResults) => ({
  type: actionTypes.SET_RSC_RESULTS_SUCCESS,
  speedCheckResults,
})

export const setRouterSpeedResultsFail = (speedCheckResultsError) => ({
  type: actionTypes.SET_RSC_RESULTS_FAILED,
  speedCheckResultsError
})

export const resetSpeedCheckResultsFlag = () => ({
  type: actionTypes.RESET_RSC_FLAGS
})
export const setResultsLoaded = (val) => ({
  type: actionTypes.SET_RESULTS_LOADED,
  val:val
})
export const setResultsLoading = (val) => ({
  type: actionTypes.SET_RESULTS_LOADING,
  val: val
})

export const logSpeedCheckResults = (routerMac, browser, elapsedTime, status) => ({
  type: actionTypes.LOG_SPEED_TEST,
  routerMac,
  browser,
  elapsedTime,
  status,
})